import React, { useEffect, useState, useRef } from 'react';
import * as bootstrap from 'bootstrap';

export const showToast = (message, type = 'primary') => {
  const event = new CustomEvent('show-toast', { detail: { message, type } });
  window.dispatchEvent(event);
};

export const showConfirm = ({ message, onConfirm, type = 'danger', size }) => {
  const event = new CustomEvent('show-confirm', {
    detail: { message, onConfirm, type, size },
  });
  window.dispatchEvent(event);
};

const ToastNotifications = () => {
  const [confirmData, setConfirmData] = useState(null);
  const confirmModalRef = useRef(null);
  const bootstrapModalRef = useRef(null);

  useEffect(() => {
    const confirmHandler = (e) => {
      setConfirmData(e.detail);
      if (!bootstrapModalRef.current) {
        bootstrapModalRef.current = new bootstrap.Modal(
          confirmModalRef.current,
          {
            backdrop: 'static',
          },
        );
      }
      bootstrapModalRef.current.show();
    };

    window.addEventListener('show-confirm', confirmHandler);
    return () => window.removeEventListener('show-confirm', confirmHandler);
  }, []);

  const handleConfirmAction = () => {
    if (confirmData?.onConfirm) {
      confirmData.onConfirm();
    }
    bootstrapModalRef.current.hide();
  };

  useEffect(() => {
    const handler = (e) => {
      const { message, type } = e.detail;
      const toastEl = document.getElementById('mainToast');
      const iconEl = document.getElementById('mainToastIcon');
      const messageEl = document.getElementById('mainToastMessage');

      const iconMap = {
        success: 'bi-check-circle-fill',
        danger: 'bi-exclamation-octagon-fill',
        warning: 'bi-exclamation-triangle-fill',
        primary: 'bi-info-circle-fill',
        info: 'bi-info-circle-fill',
      };

      const colorMap = {
        success: '#198754',
        danger: '#dc3545',
        warning: '#ffc107',
        primary: '#0d6efd',
        info: '#0dcaf0',
      };

      const selectedIcon = iconMap[type] || iconMap.primary;
      const selectedColor = colorMap[type] || colorMap.primary;

      if (iconEl && messageEl) {
        iconEl.className = `bi ${selectedIcon} fs-5`;
        iconEl.style.color = selectedColor;
        messageEl.textContent = message;

        const toast = new bootstrap.Toast(toastEl, { delay: 3500 });
        toast.show();
      }
    };

    window.addEventListener('show-toast', handler);
    return () => window.removeEventListener('show-toast', handler);
  }, []);

  return (
    <>
      {/* Toast Container */}
      <div
        className='toast-container position-fixed top-0 start-50 translate-middle-x p-3'
        style={{ zIndex: 2000 }}
      >
        <div
          id='mainToast'
          className='toast align-items-center border-0 rounded-pill shadow-lg'
          role='alert'
          aria-live='assertive'
          aria-atomic='true'
          style={{
            background: 'rgba(255, 255, 255, 0.95)',
            backdropFilter: 'blur(10px)',
            WebkitBackdropFilter: 'blur(10px)',
            minWidth: '300px',
            maxWidth: '450px',
            border: '1px solid rgba(255, 255, 255, 0.18)',
          }}
        >
          <div className='d-flex align-items-center p-2 px-3'>
            <div className='me-3 flex-shrink-0'>
              <i
                id='mainToastIcon'
                className='bi bi-info-circle-fill fs-5'
              ></i>
            </div>
            <div
              className='toast-body p-0 text-dark fw-medium small'
              id='mainToastMessage'
              style={{ lineHeight: '1.4' }}
            ></div>
            <button
              type='button'
              className='btn-close ms-auto flex-shrink-0 small'
              data-bs-dismiss='toast'
              aria-label='Close'
              style={{ fontSize: '0.65rem' }}
            ></button>
          </div>
        </div>
      </div>

      {/* Confirmation Modal */}
      <div
        className='modal fade'
        id='confirmModal'
        tabIndex='-1'
        ref={confirmModalRef}
        aria-hidden='true'
      >
        <div
          className={`modal-dialog modal-dialog-centered ${
            confirmData?.size === 'sm'
              ? 'modal-sm'
              : confirmData?.size === 'lg'
                ? 'modal-lg'
                : confirmData?.size === 'xl'
                  ? 'modal-xl'
                  : '' // defaults to medium (500px) which is wider than modal-sm
          }`}
        >
          <div
            className='modal-content border-0 shadow-lg rounded-4 overflow-hidden'
            style={{
              background: 'rgba(255, 255, 255, 0.98)',
              backdropFilter: 'blur(20px)',
            }}
          >
            <div className='modal-body p-4 text-center'>
              <div
                className={`rounded-circle d-inline-flex align-items-center justify-content-center mb-3 bg-${confirmData?.type || 'danger'} bg-opacity-10`}
                style={{ width: '60px', height: '60px' }}
              >
                <i
                  className={`bi bi-exclamation-triangle-fill fs-3 text-${confirmData?.type || 'danger'}`}
                ></i>
              </div>
              <h6 className='fw-bold text-dark mb-2'>Konfirmasi Tindakan</h6>
              <p className='text-muted small mb-0'>{confirmData?.message}</p>
            </div>
            <div className='modal-footer border-0 p-3 pt-0 gap-2'>
              <button
                type='button'
                className='btn btn-light flex-grow-1 rounded-3 small fw-bold border-0'
                data-bs-dismiss='modal'
                style={{ background: '#f1f3f5' }}
              >
                Batal
              </button>
              <button
                type='button'
                className={`btn btn-${confirmData?.type || 'danger'} flex-grow-1 rounded-3 small fw-bold shadow-sm`}
                onClick={handleConfirmAction}
              >
                Ya, Lanjutkan
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ToastNotifications;
